<ion-card *ngIf="document.serviceJob.tasks.length > 0">
    <ion-card-content (click)="display = ! display">
        <ion-label>{{ display ? 'Hide Tasks' : 'Show Tasks' }}</ion-label>
    </ion-card-content>
    <ion-card-content *ngIf="display" class="content">
        <ion-list>
            <ion-item *ngFor="let task of document.serviceJob.tasks" (click)="updateOption(task)">
                <ion-label ion-long-press>{{ task.description }}</ion-label>
                <ion-icon slot="end" [name]="tasksIcon.getIcon(task.option)"
                          [color]="tasksIcon.getColor(task.option)"></ion-icon>
            </ion-item>
        </ion-list>
    </ion-card-content>
</ion-card>
